<ng-template #footer>
  <div class="col">
    <div class="row mb-1">
      <div class="col-auto">
        <button
          class="btn btn-outline-dark btn-sm"
          [title]="'Datei hochladen' | translate"
          (click)="attachFile()"
          >
          <em class="fas fa-plus"></em>
          {{ 'Datei hochladen' | translate }}
        </button>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col">
        <div class="input-group">
          <textarea
            class="form-control"
            rows="2"
            [placeholder]="'neuer Kommentar' | translate"
            [formControl]="commentControl"
          ></textarea>
          <button
            [disabled]="(!commentControl.value && !hasImages() && !hasFiles()) || saving()"
            (click)="saveComment()"
            class="btn btn-secondary cursor-pointer hoverable"
            >
            <em class="fas fa-floppy-disk"></em>
          </button>
        </div>
      </div>
    </div>
    @if (hasFiles()) {
      <div class="row">
        <div class="col">
          @for (file of files(); track file) {
            <file-download
              [removable]="true"
              [blob]="file"
              (removeClicked)="removeFile(file)"
            ></file-download>
          }
        </div>
      </div>
    }
    @if (hasImages()) {
      <div class="row my-2">
        <div class="col">
          <strong>{{ 'Scan' | translate }}:</strong>
          @for (image of images(); track image) {
            <scanned-image-preview
              [imageData]="image"
              size="small"
              (removeClicked)="removeImage(image)"
            ></scanned-image-preview>
          }
        </div>
      </div>
    }
    <!--        <div class="row flex-nowrap g-1">-->
    <!--            <div class="col">-->
    <!--                <button-->
    <!--                    class="btn btn-sm btn-secondary w-100"-->
    <!--                    [disabled]="(!commentControl.value && !hasImages() && !hasFiles()) || saving()"-->
    <!--                    (click)="saveComment()"-->
    <!--                >-->
    <!--                    @if (!saving()) {-->
    <!--                        <em class="fas fa-message pe-1"></em>-->
    <!--                        {{ 'Kommentar hinzufügen' }}-->
    <!--                    } @else {-->
    <!--                        <div class="d-flex justify-content-center">-->
    <!--                            <iim-spinner color="primary-inverse" size="small"></iim-spinner>-->
  <!--                        </div>-->
  <!--                    }-->
<!--                </button>-->
<!--            </div>-->
<!--            <div class="col-auto">-->
<!--                <button-->
<!--                    class="btn btn-sm btn-outline-dark"-->
<!--                    [title]="'Datei anhängen' | translate"-->
<!--                    (click)="$event.stopPropagation(); attachFile()"-->
<!--                >-->
<!--                    <em class="fas fa-paperclip"></em>-->
<!--                </button>-->
<!--            </div>-->
<!--        </div>-->
</div>
</ng-template>
@if (!isDialog) {
  @if (allEntries) {
    <iim-card [header]="titleHeader" [footer]="footer">
      <ng-template #titleHeader>
        <div class="px-3">
          <div class="row align-items-center">
            <div class="col">
              <h3 class="m-0">
                {{ 'Historie' | translate }}
              </h3>
            </div>
            <div class="col-auto p-0">
              <div
                class="history-sorting scale--hover"
                (click)="cardActivities.toggleSorting()"
                [title]="'Sortierung' | translate"
                >
                @if (cardActivities.sorting === SortDirection.ASC) {
                  <em class="fas fa-arrow-up-short-wide"></em>
                } @else {
                  <em class="fas fa-arrow-down-wide-short"></em>
                }
              </div>
            </div>
            <div class="col-auto p-0">
              <button mat-icon-button class="scale--hover" (click)="expandToDialog()">
                <em class="fas fa-maximize"></em>
              </button>
            </div>
          </div>
        </div>
      </ng-template>
      <activity-display
        #cardActivities
        [activities]="allEntries()"
        [allowDeletionOfLastComment]="true"
        (deleteComment)="deleteComment($event)"
      ></activity-display>
      @if (allEntries().length === 0) {
        <div class="alert alert-info mb-0">
          {{ 'Noch keine Aktivitäten vorhanden' | translate }}
        </div>
      }
    </iim-card>
  }
} @else {
  <div class="px-3">
    <div class="row align-items-center mb-3">
      <div class="col">
        <h4>
          {{ 'Historie' | translate }}
        </h4>
      </div>
      <div class="col-auto p-0">
        <div
          class="history-sorting scale--hover"
          (click)="dialogActivities.toggleSorting()"
          [title]="'Sortierung' | translate"
          >
          @if (dialogActivities.sorting === SortDirection.ASC) {
            <em class="fas fa-arrow-up-short-wide"></em>
          } @else {
            <em class="fas fa-arrow-down-wide-short"></em>
          }
        </div>
      </div>
      <div class="col-auto p-0">
        <button mat-icon-button color="warn" (click)="closeDialog()">
          <em class="fas fa-times"></em>
        </button>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col">
        <activity-display
          #dialogActivities
          [allowDeletionOfLastComment]="true"
          [isDialog]="true"
          [activities]="allEntries()"
          (deleteComment)="deleteComment($event)"
        ></activity-display>
        @if (allEntries().length === 0) {
          <div class="alert alert-info">
            {{ 'Noch keine Aktivitäten vorhanden' | translate }}
          </div>
        }
      </div>
    </div>
    <div class="row mb-2">
      <div class="col">
        <ng-container *ngTemplateOutlet="footer"></ng-container>
      </div>
    </div>
  </div>
}
